import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IPlanetDeviceWithFingotiDevice } from '../../types/PlanetDevice/PlanetDevice';
import { planetDeviceQueryKeys } from '../QueryKeys';

export default function usePlanetDevice(deviceId?: string, shouldPoll = false) {
  const { get } = useApiHelper();

  const planetDevice = useQuery({
    queryKey: planetDeviceQueryKeys.single(deviceId ?? ''),
    queryFn: () =>
      get<IDefaultResponseWithData<IPlanetDeviceWithFingotiDevice>>(
        `/v1/device/${deviceId}?includeGateway=true`
      ).then((res) => res.data.data),
    refetchInterval: shouldPoll ? 5000 : false,
    enabled: !!deviceId && deviceId !== '',
  });

  return {
    planetDevice,
  };
}
